import React from 'react';
import {
    Form, Row, Col, Input, Button
} from 'antd';
class FD extends React.Component {
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.submitHandler({ ...values, id: this.props.id }, (val) => {
                    if (!val) {
                    }
                });
            }
        });
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div className="mi_model_popup">
                <Row span={24}>
                    <Col span={18}>
                        <p style={{ marginLeft: "14px" }} className='mi_title'>{this.props.title}</p>
                    </Col>
                    <Col span={6}>
                        <i className="fa fa-times mi_icon mi_icon_red mi_button_close" style={{ color: 'red' }} onClick={this.props.closeDrawerHandler} ></i>
                    </Col>
                </Row>
                <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
                    <Row span={24}>
                        <Col sm={24}>
                            <Form.Item>
                                <fieldset className="mi_fieldset1 mi_input_pop">
                                    <legend className="legend-font">Email Id</legend>
                                    {getFieldDecorator('email', {
                                        rules: [{
                                            type: 'email', message: 'Please enter valid Email..',
                                        }, { required: true, message: 'Please enter  email id.' },
                                        { whitespace: true, message: "Email is invalid." },
                                        {
                                            pattern: /^([a-zA-Z0-9\s.]+)@([a-zA-Z0-9]+)\.([a-zA-Z]{2,5})$/,
                                            message: 'Email is invalid.'
                                        }],
                                    })(<Input type="email" autoComplete={"nope"} className="mi_input" placeholder="Enter Email Id *" />)}
                                </fieldset>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row span={24} style={{ marginTop: '20px' }}>
                        <Col span={7} ></Col>
                        <Col span={5} >
                            <Button className="mi_button_right submit-button" onClick={this.props.closeDrawerHandler} style={{ marginRight: 8 }}>
                                Cancel
                            </Button>
                        </Col>
                        <Col span={5} >
                            <Button htmlType="submit" className="submit-button" type="primary" >
                                Submit
                            </Button>
                        </Col>
                        <Col span={7} >
                            {/* <img alt="example" style={{ width: 105, marginBottom: '-28px', float: 'right' }} src={img} /> */}
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}
const Invitemember = Form.create()(FD);
export default Invitemember;